import { formatDateInput } from '@/lib/format/date';
import { formatTextOrDash } from '@/lib/format/text';
import { formValue } from '@/lib/mappers/formValues';
import {
  BACK_TO_BACK_FIELDS,
  EMPTY_BACK_TO_BACK_FORM,
} from '../constants/backToBackAccounts.constants';

const trimmed = (value) => (value ?? '').trim();

const backToBackFormValues = (dto) => ({
  ...EMPTY_BACK_TO_BACK_FORM,
  [BACK_TO_BACK_FIELDS.accountName]: formValue(dto.accountName),
  [BACK_TO_BACK_FIELDS.accountId]: formValue(dto.accountId),
  [BACK_TO_BACK_FIELDS.isccCertificateNumber]: formValue(dto.isccCertificateNumber),
  [BACK_TO_BACK_FIELDS.isccVerified]: Boolean(dto.isIsccVerified),
  [BACK_TO_BACK_FIELDS.validFrom]: formatDateInput(dto.validFrom),
  [BACK_TO_BACK_FIELDS.validTill]: formatDateInput(dto.validTill),
  [BACK_TO_BACK_FIELDS.officialSiteName]: formValue(dto.officialSiteName),
  [BACK_TO_BACK_FIELDS.addressLine1]: formValue(dto.addressLine1),
  [BACK_TO_BACK_FIELDS.addressLine2]: formValue(dto.addressLine2),
  [BACK_TO_BACK_FIELDS.cityName]: formValue(dto.cityName),
  [BACK_TO_BACK_FIELDS.countryName]: formValue(dto.countryName),
  [BACK_TO_BACK_FIELDS.zipCode]: formValue(dto.zipCode),
});

export const processBackToBackAccount = (dto) => ({
  id: dto.id,
  accountName: formatTextOrDash(dto.accountName),
  accountId: formatTextOrDash(dto.accountId),
  isccCertificateNumber: formatTextOrDash(dto.isccCertificateNumber),
  officialSiteName: formatTextOrDash(dto.officialSiteName),
  addressLine1: formatTextOrDash(dto.addressLine1),
  addressLine2: formatTextOrDash(dto.addressLine2),
  cityName: formatTextOrDash(dto.cityName),
  countryName: formatTextOrDash(dto.countryName),
  zipCode: formatTextOrDash(dto.zipCode),
  formValues: backToBackFormValues(dto),
});

export const buildBackToBackAccountDto = (values) => {
  const certificateNumber = trimmed(values[BACK_TO_BACK_FIELDS.isccCertificateNumber]);
  const isVerified = certificateNumber !== '' && values[BACK_TO_BACK_FIELDS.isccVerified] === true;

  return {
    accountName: trimmed(values[BACK_TO_BACK_FIELDS.accountName]),
    accountId: trimmed(values[BACK_TO_BACK_FIELDS.accountId]),
    officialSiteName: trimmed(values[BACK_TO_BACK_FIELDS.officialSiteName]),
    addressLine1: trimmed(values[BACK_TO_BACK_FIELDS.addressLine1]),
    addressLine2: trimmed(values[BACK_TO_BACK_FIELDS.addressLine2]),
    cityName: trimmed(values[BACK_TO_BACK_FIELDS.cityName]),
    countryName: trimmed(values[BACK_TO_BACK_FIELDS.countryName]),
    zipCode: trimmed(values[BACK_TO_BACK_FIELDS.zipCode]),
    ...(isVerified
      ? {
          isccCertificateNumber: certificateNumber,
          isIsccVerified: true,
          validFrom: values[BACK_TO_BACK_FIELDS.validFrom] || undefined,
          validTill: values[BACK_TO_BACK_FIELDS.validTill] || undefined,
        }
      : {}),
  };
};
